import React, { Fragment, useState } from "react";
import FamilyWrapper from "./family.style";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
import { updateApplicant } from "../../../../redux/actions/travel";
import TravelerList from "../TravelerList/travelerList";
import AddTraveler from "../AddTraveler/addTraveler";
import { withTranslation } from "react-i18next";
import * as globalUtils from "../../../../helpers/utils";
import { useSelector, useDispatch } from "react-redux";

const Family = ({ t, i18n, familyChecked, needFamilyToggle = true, setFamilyCheckFlag }) => {
    //  ;
    const showRTL = globalUtils.isArabic(i18n.language);
    const dispatch = useDispatch();

    const applicants = useSelector((state) => state.travel.applicants);
    const [familyToggle, setFamilyToggle] = useState(false);

    const [showTravelerPopup, setShowTravelerPopup] = useState(false);
    const [popupType, updatePopupType] = useState("");

    const handlePopup = (key) => {
        setShowTravelerPopup(true);
        updatePopupType(key);
    };

    const addNewTraveller = (data) => {
        setShowTravelerPopup(false);
        applicants.applicants.push(data);
        dispatch(updateApplicant(applicants));
    };

    const toggle = (flag) => {
        setFamilyToggle(flag);
        setFamilyCheckFlag(flag)
    };

    return (
        <FamilyWrapper>
            <TravelerList selfView={true} />
            {applicants.self && applicants.self.nationalId && needFamilyToggle && (
                <div className="d-flex mb-4">
                    <InputSwitch
                        disabled={!familyChecked}
                        checked={familyToggle}
                        // onChange={(e) => setFamilyToggle(e.value)}
                        onChange={(e) => toggle(e.value)}
                    />
                    <div className={showRTL ? "switch-text-rtl" : "switch-text"}>
                        {t("im-traveling-with-your-family-or-friends")}
                    </div>
                </div>
            )}
            {applicants.self && applicants.self.nationalId && familyToggle && (
                <Fragment>
                    <div className="family-div">
                        <h2 className={showRTL ? "d-none d-md-block title-rtl" : "d-none d-md-block title"}>
                            {t("family")}
                        </h2>
                        <h2 className={showRTL ? "d-bock d-md-none title-rtl" : "d-bock d-md-none title"}>
                            {t("dependents")}
                        </h2>
                        <TravelerList applicantsView={true} />
                        <div className={showRTL ? "text-end" : "text-initial"}>
                            <Button
                                type="button"
                                label={t("add-new-family")}
                                icon="pi pi-plus"
                                iconPos="right"
                                onClick={() => handlePopup("ADD_FAMILY_FRIEND")}
                            />
                        </div>
                    </div>
                    {/* <div className="friends-div">
                        <h2 className={showRTL ? 'd-none d-md-block title-rtl' : 'd-none d-md-block title'}>{t('friends')}</h2>
                        <h2 className={showRTL ? 'd-bock d-md-none title-rtl' : 'd-bock d-md-none title'}>{t('other-travelers')}</h2>
                        <TravelerList model="friends" />
                        <div className={showRTL ? "text-end" : "text-initial"}>
                            <Button
                                type="button"
                                label={t('add-new-traveler')}
                                icon="pi pi-plus"
                                iconPos="right"
                                onClick={() => handlePopup("ADD_FRIENDS")}
                            />
                        </div>
                    </div> */}
                </Fragment>
            )}
            <AddTraveler
                show={showTravelerPopup}
                type={popupType}
                onPopupClose={() => setShowTravelerPopup(false)}
                onSuccess={addNewTraveller}
            />
        </FamilyWrapper>
    );
};

export default withTranslation()(Family);
